<template>
    <div class="contact_card">
        <div class="contact_card--title">
            <h2>
                {{city}}
            </h2>
        </div>
        <div class="contact_card--centers">
            <p @click="getAddress(item.id)" v-for="item in address" :key="item.id">{{item.place}}</p>
        </div>
    </div>
</template>

<script>
    import { locationsForCity } from './contacts/pickup_locations';

    export default {
        name: "contacts_card",
        props:{
            city: String,
            centers: Array
        },
        computed: {
            address() {
                return locationsForCity(this.centers, this.city).map(i => {
                    return { place: i.attributes.address, id: i.attributes.id }
                })
            }
        },
        methods: {
            getAddress (id) {
                this.$emit('id', {
                   id: id
                })
            }
        }
    }
</script>

<style scoped>
</style>
